import ProfileContainer from './profile_container';

const Profile = ProfileContainer;
export default Profile;
